import i18next from "i18next";
import { ZodError, z } from "zod";

// zod v4 では zod-i18n-map（v3 専用）が使えないため、標準メッセージは
// zod 組み込みの日本語ロケールを使い、プロジェクト固有のカスタム文言のみ
// i18next で補間して customError で解決する。
i18next.init({
  lng: "ja",
  resources: {
    ja: {
      custom: {
        required: "必須",
        invalid_file_type: "ファイル種別が正しくありません。（{{type}}）",
        too_big: {
          file_size: "ファイルサイズは{{maximum}}MB以下にしてください。",
        },
      },
    },
  },
});

type I18nParam =
  | string
  | { key: string; values?: Record<string, unknown> };

z.config({
  // 標準エラーメッセージの日本語ロケール（フォールバック）
  ...z.locales.ja(),
  // プロジェクト固有のカスタムメッセージ。未処理の場合は undefined を返して
  // localeError（上記 z.locales.ja()）にフォールバックさせる。
  customError: (issue) => {
    // cuid2 バリデーション失敗は「必須」（隠しフィールドの relation ID 等）
    if (issue.code === "invalid_format" && issue.format === "cuid2") {
      return "必須";
    }

    // refine の params.i18n 規約（旧 zod-i18n-map 互換）
    const i18n = (issue.params as { i18n?: I18nParam } | undefined)?.i18n;
    if (i18n) {
      if (typeof i18n === "string") {
        return i18next.t(i18n, { ns: "custom" });
      }
      return i18next.t(i18n.key, { ns: "custom", ...i18n.values });
    }

    return undefined;
  },
});

export { z, ZodError };
